import {
    SUB_PROFILES_FETCH,
    SUB_PROFILES_IS_FETCING,
    SUB_PROFILES_API,
    SUB_PROFILE_EDIT,
    SUB_PROFILE_FILTER,
		SINGLE_SUB_PROFILE_FETCH,
		SUB_PROFILES_ABS_REBATE_VALUES_FETCH
} from 'constants/subProfiles'

//HTTP reuests actions
import {
    put,
    post,
    remove,
    get
} from 'actions/requests'


export const subProfileSave = (data) => (dispatch, state) => {
    let action;
    if (data.subProfileId)
        action = put;
    else
        action = post;
    dispatch(subProfilesIsFetching(true))
    return action(SUB_PROFILES_API, data)
        .finally(e => dispatch(subProfilesIsFetching(false)))

}

export const subProfileFetch = (id) => (dispatch, state) => {
        dispatch(subProfilesIsFetching(true));
        return get(SUB_PROFILES_API + '/' + id)
            .then((p) =>{
                dispatch(fetchedSingleSubProfile(p))
                return p
            })
            .finally(e => dispatch(subProfilesIsFetching(false)))

}

export const subProfileAbsoluteRebateValues = (profileId, ibId) => (dispatch, state) => {
	let params = {
		profileId,
		ibId
	}
	dispatch(subProfilesIsFetching(true))
	return get(`${SUB_PROFILES_API}/absolute-rebate-values`, params)
			.then((e) => {
					dispatch(subProfileAbsoluteRebateValuesFetch(e))
					return e
			})
			.finally(e => dispatch(subProfilesIsFetching(false)))
}

export const subProfilesFetch = (data) => (dispatch, state) => {
    dispatch(subProfilesIsFetching(true));
    const filter = state().profiles.pageable
    const sorted = Object.keys(filter.sort).find(e => filter.sort[e])
    let params = {
        size: filter.size,
        page: filter.page,
        sort: sorted + ',' + filter.sort[sorted]
    }
    return get(SUB_PROFILES_API, params)
        .then((e) => {
            dispatch(subProfilesFetched(e.content))
            return e
        })
        .then((e) => {
            dispatch(
                subProfileFilter({
                    totalPages: e.totalPages
                })
            )
            return e
        })
        //disable loading
        .finally(e => dispatch(subProfilesIsFetching(false)))
}

export const subProfileRemove = (id) => (dispatch, state) => {
    dispatch(subProfilesIsFetching(true))
    return remove(SUB_PROFILES_API + '/' + id)
        .finally(e => dispatch(subProfilesIsFetching(false)))
}
export const subProfileAbsoluteRebateValuesFetch = (payload) => ({ type: SUB_PROFILES_ABS_REBATE_VALUES_FETCH, payload: payload })
export const subProfilesFetched = (payload) => ({ type: SUB_PROFILES_FETCH, payload: payload })
export const subProfilesIsFetching = (payload) => ({ type: SUB_PROFILES_IS_FETCING, payload: payload })
export const profileEdit = (id, data) => ({ type: SUB_PROFILE_EDIT, payload: data })
export const subProfileFilter = (data) => ({ type: SUB_PROFILE_FILTER, payload: data })
export const fetchedSingleSubProfile = (data) => ({type: SINGLE_SUB_PROFILE_FETCH, payload: data})



// WEBPACK FOOTER //
// ./src/actions/subProfiles.js